const hotel = {
  availableMealPlans: "Planes de comidas disponibles", // translated
  availableRoomsTypes: "Tipos de habitaciones disponibles", // translated
  cancellationPolicy: "Política de cancelación", // translated
  freeCancellationAvailable: "Cancelación gratuita disponible", // translated
  nonRefundable: "No reembolsable", // translated
  priceFor: "precio por", // translated
  nights: "noches", // translated
  totalPrice: "Precio total", // translated
  seeAvailability: "Ver disponibilidad", // translated
  myProfile: "Mi perfil", // translated
  travelTrust: "Fideicomiso de viaje", // translated
  signIn: "Iniciar sesión", // translated
  searchNow: "Buscar ahora", // translated
  policy: "Política", // translated
  hotelName: "Nombre del hotel", // translated
  maxPax: "Personas máximas", // translated
  room: "habitación", // translated
  reservationDate: "Fecha de Reserva", // translated
  beddingType: "Tipo de ropa de cama", // translated
  cxlPolicy: "Política CXL", // translated
  cancellationRules: "Reglas de cancelación", // translated
  cxlRules: "Reglas CXL", // translated
};

export default hotel;
